module.exports = __webpack_public_path__ + "static/media/Refinery29.8c604dcc.png";